export async function getAudioMedia(constraints: any = {}): Promise<MediaStream> {
  try {
    return await navigator.mediaDevices.getUserMedia({
      audio: constraints,
      video: false,
    })
  } catch (err: any) {
    if (err.name === 'OverconstrainedError' && constraints.deviceId) {
      const fallback = { ...constraints }
      delete fallback.deviceId
      return navigator.mediaDevices.getUserMedia({
        audio: fallback,
        video: false,
      })
    }
    throw err
  }
}
